export default "__VITE_ASSET__ac84a748__"